import React from 'react'
import { Spin } from 'antd'

const Loader = () => {
  return (
    <div classname='loader'><Spin /></div>
  )
}

export default Loader
